var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4205_8904",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "url(#pattern0_4205_8904)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4205_8904)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#0052A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_4205_8904",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4205_8904",
    transform: "scale(0.0166667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4205_8904",
    width: 60,
    height: 60,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon1);
export default __webpack_public_path__ + "static/media/service-icon1.a541c6f579f93e1aba89cf6d3352869d.svg";
export { ForwardRef as ReactComponent };